var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"enum":_vm.cinsiyet,"labels":_vm.cinsiyetLabel,"rules":_vm.rules,"label":_vm.label ? _vm.label : 'Cinsiyet'},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }